export const SETTINGS_STORAGE_KEY = 'SYNERGIES_SETTINGS';
